module.exports = __webpack_public_path__ + "static/media/game.bccbd604.png";